export const TrapezoidIcon = () => {
  const size = 50;
  const points = [
    { x: -size, y: -size / 2 },
    { x: size, y: -size / 2 },
    { x: size * 0.6, y: size / 2 },
    { x: -size * 0.6, y: size / 2 },
  ].map(p => `${p.x},${p.y}`).join(' ');

  return (
    <svg width="40" height="40" viewBox="-60 -60 120 120">
      <polygon points={points} fill="#fff" stroke="#333" strokeWidth="2" />
    </svg>
  );
};